import {ReactNode} from "react";
import {Link} from "./widgets";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const LinkWithMagnifier = ({to, children}: {to: string; children: ReactNode}) => {
    return (
        <Link to={to} openInNewTab>
            {children}
            <FontAwesomeIcon icon="magnifying-glass" size="xs" style={{marginLeft: 4}} />
        </Link>
    );
};

export default LinkWithMagnifier;
